$(document).foundation();

App.SiteNav.initialize();
App.PageHome.initialize();
App.WellnessVillage.initialize();
App.SubnavMenus.initialize();
App.TextFormatterVideoEmbedModifier.initialize();
